import type { Option } from '@byecode/ui'
import { Select } from '@byecode/ui'
import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'

import { otherPlatformColorMap, otherPlatformIconMap, otherPlatformNameMap } from '@/containers/OtherPlatforms/constant'
import { openOtherPlatform } from '@/containers/OtherPlatforms/OtherPlatformEvent'
import { useGetAiModelList } from '@/shared/reusable'

const SCxAuth = styled.div`
    width: 72px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background: var(--color-white);
    border-radius: 6px;
    box-shadow: 0 4px 12px 0 #1018281a;
    color: var(--color-gray-900);
    font-size: 12px;
`

type Props = {
    value: string
    disabledModels?: string[]
    onChange: (value: string) => void
}

const SelectModel: React.FC<Props> = ({ value, disabledModels, onChange }) => {
    const { data } = useGetAiModelList()

    const onSelect = useCallback(
        (val: string) => {
            const aiModal = data?.find(item => item.modules.some(module => module.value === val))
            if (!aiModal) {
                return
            }
            if (!aiModal.configurationComplete) {
                openOtherPlatform({
                    type: aiModal?.type
                })
                return
            }

            onChange(val)
        },
        [data, onChange]
    )

    const list = useMemo(() => {
        return data?.reduce<Option[]>((prev, cur) => {
            // const isMatch = cur.name.toLowerCase().includes(lowerCaseSearch)
            const childList = cur?.modules.reduce<Option[]>((list, module) => {
                if (!disabledModels || !disabledModels?.includes(module.value)) {
                    list.push({
                        ...module,
                        icon: otherPlatformIconMap[cur.type],
                        iconColor: otherPlatformColorMap[cur.type],
                        extra: !cur.configurationComplete && <SCxAuth>需完善授权</SCxAuth>
                    })
                }
                return list
            }, [])
            if (childList && childList.length > 0) {
                prev.push({
                    label: `${otherPlatformNameMap[cur.type]}${cur.system ? '（内置）' : ''}`,
                    value: cur.type,
                    children: childList
                })
            }
            return prev
        }, [])
    }, [data, disabledModels])

    return <Select size="lg" searchable options={list} value={value} onChange={onSelect} />
}

export default SelectModel
